import { render, staticRenderFns } from "./IconWarning.vue?vue&type=template&id=0544c508&"
import script from "./IconWarning.vue?vue&type=script&lang=ts&"
export * from "./IconWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports